import styled from 'styled-components';

export default styled.h2`
  color: ${(props) => props.theme.carvana.blue.dark};
`;
